var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 601 601",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.429 33.8323C241.138 12.1841 269.955 0.230774 300.589 0.230774C331.224 0.230774 360.096 12.129 381.75 33.8323C403.403 55.5356 415.36 84.2897 415.36 114.972C415.36 145.654 403.403 174.463 381.75 196.111L300.589 277.251L219.429 196.111C197.775 174.408 185.819 145.654 185.819 114.972C185.819 84.2897 197.72 55.4805 219.429 33.8323ZM405.102 219.409C449.842 174.68 522.628 174.68 567.368 219.409V219.464C612.108 264.192 612.108 336.959 567.368 381.688C522.628 426.416 449.842 426.416 405.102 381.688L323.942 300.548L405.102 219.409ZM300.589 323.903L219.429 405.043C197.775 426.691 185.819 455.5 185.819 486.182C185.819 516.864 197.775 545.618 219.429 567.322C241.083 588.97 269.899 600.923 300.589 600.923C331.279 600.923 360.041 588.97 381.75 567.322C403.403 545.673 415.36 516.864 415.36 486.182C415.36 455.5 403.403 426.746 381.75 405.043L300.589 323.903ZM33.7858 381.688C-10.9543 336.959 -10.9543 264.193 33.7858 219.464V219.409C78.5259 174.68 151.311 174.68 196.051 219.409L277.212 300.548L196.051 381.688C151.311 426.417 78.5259 426.417 33.7858 381.688Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.533d775d.svg";
export { ForwardRef as ReactComponent };